import { ComponentProps, FC } from 'react';

import { Tooltip } from '@purpur/library';

import { COMMON_TEST_ID } from '@telialt/test/src/test-ids';

export const CustomPurpurTooltip: FC<ComponentProps<typeof Tooltip>> = ({ className, ...props }) => (
    <Tooltip data-testid={COMMON_TEST_ID.TOOLTIP} {...props} contentClassName={className} />
);
